export const contestSectionData = {
  NeedToDo: {
    steps: [
      {
        icon: '/icons/contestCar.svg',
        label: 'Browse cars on\nACKO Drive',
        alt: 'Explore cars icon',
      },
      {
        icon: '/icons/contestWishlist.svg',
        label: 'Wishlist 5 cars\nyou like',
        alt: 'Wishlist icon',
      },
      {
        icon: '/icons/contestThumbsUp.svg',
        label: "That's it,\nyou're in!",
        alt: 'Thumbs up icon',
      },
    ],
  },
};

